import { REHYDRATE } from 'redux-persist'
import { constants } from '../constants/redux-constants'

const initialState = {
    clinicalTrialUser:{}
}

const ClinicalTrialsReducer = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE:
            return {
                ...state,
                ...(action.payload?.clinicalTrialUser || {}),
            }
        case constants.RESET:
            return {
                ...initialState,
            }
        case constants.CLINICAL_TRIALS?.SET_CLINICAL_TRIAL_USER:
            return {
                ...state,
                clinicalTrialUser: action.payload,
            }
        default:
            return {
                ...state,
            }
    }
}

export default ClinicalTrialsReducer
